import { createContext } from 'react';
interface TimerContextType {
    initialTime: number;
    setInitialTime: (time: number) => void;
    time: number;
    isRunning: boolean;
    startTimer: () => void;
    stopTimer: () => void;
    resetTimer: () => void;
    setTime: (time: number) => void;
    formatTime: (seconds: number) => string;
    removeTime: (secondsToRemove: number) => void;
}

export const TimerContext = createContext<TimerContextType | undefined>(undefined);
